module.exports = __webpack_public_path__ + "static/media/bg_speciality.b377b4f9.png";